import React, { useEffect, useMemo, useState } from 'react';
import { IGame, ITeamMember } from '@incentivegames/ig-types/lib/interfaces/apiContracts';
import { userLoggingUtilities } from '@incentivegames/ig-frontend-common/lib/utilities/userAgentLogUtilities';
import { useSelector } from 'react-redux';
import { IRootState } from 'store/serverInterfaces';
import Loading from 'components/Loading';
import WidgetCardContainer from 'components/WidgetCardContainer';

import './Widget.scss';

const Widget = () => {
  const game: IGame | undefined = useSelector(({ DreamteamReducer: state }: IRootState) => state.games?.find((game: IGame) => game.gameId === state.currentGameId));
  const [loading, setLoading] = useState<boolean>(true);
  const promoTeamMembers: ITeamMember[] = game?.promoTeams?.[0]?.team || [];
  const gameClosed: boolean = !!game && game.closeTime <= Date.now() && promoTeamMembers.length > 0;

  useEffect(() => {
    if (game) {
      setLoading(false);
    }
  }, [game]);

  // Change app background colour while widget page is mounted
  useEffect(() => {
    document.body.classList.add('widget__body-background');
    return () => {
      document.body.classList.remove('widget__body-background');
    };
  }, []);

  const systemVariant: string = useMemo(() => {
    switch (userLoggingUtilities.getUserDeviceLog().os) {
      case 'iOS':
        return 'ios';
      case 'Android':
        return 'android';
      default:
        return 'web';
    }
  }, []);

  return <div className={`widget widget--${systemVariant}`}>{loading ? <Loading showText={false} height="27px" /> : <WidgetCardContainer initTeam={promoTeamMembers} closed={gameClosed} />}</div>;
};

export default Widget;
